import { Pipe, PipeTransform } from "@angular/core";
import { date_delta } from "./utils";

@Pipe({ name: 'deltadate' })
export class DateDeltaPipe implements PipeTransform {
   transform(value: Date | string): string {
      return `hace ${date_delta(value)}`;
   }
}